import React from 'react';
import { Bar } from 'react-chartjs-2';
import { useTheme } from '@mui/material/styles';

const MohiniBarGraph = ({ data }) => {
  const theme = useTheme();
  const safeData = Array.isArray(data) ? data : [];
  // Assuming data has an additional 'screen' field indicating 'Screen 1' or 'Screen 2'
  // const screenCategories = ['Screen 1', 'Screen 2'];
  // console.log("data",data);
  const screenCategories = Array.from(
    new Set(
      safeData
        .map((item) => item?.LocationName)
        .filter(Boolean)
    )
  );

  // Aggregate counts for each screen category
  const aggregatedData = screenCategories.reduce((acc, LocationName) => {
    acc[LocationName] = {
      popcorn: 0,
      cooldrink: 0
      // sweetcorn: 0
    };
    safeData.forEach(item => {
      if (item.LocationName === LocationName) {
        acc[LocationName].popcorn += Number(item.pop_corn_count) || 0;
        acc[LocationName].cooldrink += Number(item.cool_drink_count) || 0;
        // acc[LocationName].sweetcorn += item.sweetcorn_count;
      }
    });
    return acc;
  }, {});

  // Separate data for each category
  const popcornCounts = screenCategories.map(LocationName => aggregatedData[LocationName].popcorn);
  const cooldrinkCounts = screenCategories.map(LocationName => aggregatedData[LocationName].cooldrink);
  // const sweetcornCounts = screenCategories.map(screen => aggregatedData[screen].sweetcorn);

  // Find the maximum value among all counts
  const maxCount = Math.max(
    ...popcornCounts,
    ...cooldrinkCounts,
    // ...sweetcornCounts
  );
  const nearestMultipleOf50 = maxCount > 0 ? Math.ceil(maxCount / 50) * 50 : 50;
  const isLight = theme.palette.mode === 'light';
  const axisColor = isLight ? '#111827' : '#ffffff';
  const gridColor = isLight ? 'rgba(17, 24, 39, 0.18)' : 'rgba(255, 255, 255, 0.2)';

  if (screenCategories.length === 0) {
    return null;
  }

  const chartData = {
    labels: screenCategories,
    datasets: [
      {
        label: 'Popcorn',
        backgroundColor: 'rgba(250, 218, 95, 1)',
        barPercentage: 0.55,
        categoryPercentage: 0.55,
        maxBarThickness: 80,
        data: popcornCounts
      },
      {
        label: 'Cooldrink',
        backgroundColor: 'rgba(226, 133, 129, 1)',
        barPercentage: 0.55,
        categoryPercentage: 0.55,
        maxBarThickness: 80,
        data: cooldrinkCounts
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'x',
    scales: {
      y: {
        beginAtZero: true,
        max: nearestMultipleOf50,
        title: {
          display: true,
          text: 'Count',
          color: axisColor,
        },
        ticks: {
          color: axisColor, // y-axis label color
        },
        grid: {
          color: gridColor, // y-axis grid line color
          borderColor: axisColor, // y-axis line color
        },
        border: {
          color: axisColor,
        },
      },
      x: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Screens', 
          color: axisColor,
        },
        ticks: {
          color: axisColor, // x-axis label color
        },
        grid: {
          color: gridColor, // x-axis grid line color
          borderColor: axisColor, // x-axis line color
        },
        border: {
          color: axisColor,
        },
      }
    },
    plugins: {
      legend: {
        labels: {
          color: axisColor, // legend text color
        },
      },
      datalabels: {
        color: 'black',
      },
    },
  };

  return (
    <div style={{ height: 420, width: '100%' }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default MohiniBarGraph;
